/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_tools_available_now = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available Now`)
};

const es_home_tools_available_now = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible ahora`)
};

const de_home_tools_available_now = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt verfügbar`)
};

const nl_home_tools_available_now = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu beschikbaar`)
};

const fr_home_tools_available_now = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible maintenant`)
};

const it_home_tools_available_now = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibile ora`)
};

const pt_br2_home_tools_available_now = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponível agora`)
};

const pt_home_tools_available_now = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponível agora`)
};

const ja_home_tools_available_now = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今すぐ利用可能`)
};

const zh_home_tools_available_now = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即可用`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_tools_available_now = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_tools_available_now(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_tools_available_now", locale)
	if (locale === "en") return en_home_tools_available_now(inputs)
	if (locale === "es") return es_home_tools_available_now(inputs)
	if (locale === "de") return de_home_tools_available_now(inputs)
	if (locale === "nl") return nl_home_tools_available_now(inputs)
	if (locale === "fr") return fr_home_tools_available_now(inputs)
	if (locale === "it") return it_home_tools_available_now(inputs)
	if (locale === "pt-BR") return pt_br2_home_tools_available_now(inputs)
	if (locale === "pt") return pt_home_tools_available_now(inputs)
	if (locale === "ja") return ja_home_tools_available_now(inputs)
	return zh_home_tools_available_now(inputs)
};